<template>
  <vs-row vs-w="12" >
    <vs-col vs-w="12">
      <vs-input label="Name" type="text" v-model="policy.identifier" />
    </vs-col>

    <edit-opening-hours-policy-limit
      label="Hard limit:"
      :limit="getLimit(POLICY_LIMIT_TYPE.Hard)"
      :limit-type="POLICY_LIMIT_TYPE.Hard"
      @limit-removed="handleLimitRemoved"
      @limit-added="handleLimitAdded"
    />

    <edit-opening-hours-policy-limit
      label="Soft limit:"
      :limit="getLimit(POLICY_LIMIT_TYPE.Soft)"
      :limit-type="POLICY_LIMIT_TYPE.Soft"
      @limit-removed="handleLimitRemoved"
      @limit-added="handleLimitAdded"
    />

    <!-- <edit-opening-hours-policy-limit
      label="Warning limit:"
      :limit="getLimit(POLICY_LIMIT_TYPE.Warning)"
      :limit-type="POLICY_LIMIT_TYPE.Warning"
      @limit-removed="handleLimitRemoved"
      @limit-added="handleLimitAdded"
    /> -->

  </vs-row>
</template>

<script>

import { POLICY_LIMIT_TYPE, OpeningHoursPolicyLimit} from "@/store/modules/marcom/data-model/policy-configurations";
import EditOpeningHoursPolicyLimit from "./EditOpeningHoursPolicyLimit.vue";

export default {
  props: {
    policy: Object
  },
  components: {
    EditOpeningHoursPolicyLimit
  },
  data() {
    return {
      POLICY_LIMIT_TYPE
    };
  },
  computed: {
  },
  methods: {
    getLimit(limitType) {
      let index = this.policy.limits.findIndex(
        (l) => l.limitType === limitType
      );
      if (index === -1) return null;
      return this.policy.limits[index];
    },
    handleLimitRemoved(limitType) {
      this.policy.limits = this.policy.limits.filter(
        (l) => l.limitType !== limitType
      );
    },
    handleLimitAdded(limitType) {
      this.policy.limits.push(new OpeningHoursPolicyLimit(limitType, '18:00', '23:00'));
    },
  },
};
</script>
